import React from 'react';
import {
  Button,
  Form,
  Grid,
  Header,
  Image,
  Message,
  Segment,
} from 'semantic-ui-react';
import { Field, reduxForm } from 'redux-form';

import { ReduxField } from '../';
import validate from '../../validate';

const LoginForm = props => {
  const { handleSubmit, submitting, submitFailed } = props;
  return (
    <div className="login-form">
      {/*
        Heads up! The styles below are necessary for the correct render of this example.
        You can do same with CSS, the main idea is that all the elements up to the `Grid`
        below must have a height of 100%.
      */}
      <style>{`
        body > div,
        body > div > div,
        body > div > div > div.login-form {
          height: 100%;
        }
      `}</style>
      <Grid
        textAlign="center"
        style={{ height: '100%' }}
        verticalAlign="middle"
      >
        <Grid.Column style={{ maxWidth: 450 }}>
          <Header as="h2" color="teal" textAlign="center">
            <Image src="https://react.semantic-ui.com/logo.png" /> Log in to
            your account
          </Header>
          <Form onSubmit={handleSubmit} size="large">
            <Segment stacked>
              <Field
                name="email"
                type="text"
                component={ReduxField}
                label="Email address"
              />
              <Field
                name="password"
                type="password"
                component={ReduxField}
                label="Password"
              />

              {submitFailed && (
                <Message style={{ marginTop: '0' }} negative compact>
                  Invalid email/password combo. Please try again.
                </Message>
              )}
              <Button
                disabled={submitting}
                type="submit"
                loading={submitting}
                fluid
                primary
                size="big"
              >
                Login
              </Button>
            </Segment>
          </Form>
          <Message>
            New user? <a href="/signup">Sign Up</a>
          </Message>
        </Grid.Column>
      </Grid>
    </div>
  );
};

export default reduxForm({
  form: 'login',
  validate,
})(LoginForm);



// WEBPACK FOOTER //
// ./src/containers/Login/components/LoginForm/index.jsx